import Simplemodal from '../../plugins/simplemodal.js';

const fullScreenMenu = new Simplemodal({
  trigger : "data-fullScreenMenu-trigger",
  clickOutSideClose : true,
  backFixed:false
})

const modal01 = new Simplemodal({
  trigger : "data-simplemodal-trigger",
  clickOutSideClose : true,
  backFixed:true
});

//ハンバーガーメニューの開閉時のaタグクリック時の処理
document.querySelectorAll('.fullScreenMenu-content a').forEach(function(element) {
  element.addEventListener('click', function(event) {
    const isInternalLink = event.currentTarget.getAttribute('href').startsWith('#');
    const menuContent = document.querySelector('.fullScreenMenu-content');
    const menuButton = document.querySelector('.fullScreenMenu-button');
    const jsMenuContent = document.querySelector('.js-fullScreenMenu-content');

    if (isInternalLink) {
      // ページ内アンカーリンクの場合
      const targetId = event.currentTarget.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        event.preventDefault(); // デフォルトのページ遷移を防ぐ
        targetElement.scrollIntoView({ behavior: 'smooth' }); // スムーズにスクロール
      }
    }

    menuContent.classList.remove('is-open');
    menuButton.classList.remove('is-open');
    menuButton.setAttribute('aria-expanded', 'false');

    if (jsMenuContent) {
      jsMenuContent.classList.remove('is-open');
      jsMenuContent.classList.add('is-close');
    }
  });
});
